import { scanThroughConstants } from 'utils/constants/scan-constants'

export const settingsOptions = {
	YES: 'yes',
	NO: 'no'
}

export const privacyOptions = {
	NO: 'no',
	TEAM: 'team',
	EVERYBODY: 'everybody',
}

export const settingsConstants = {
	// Theme
	THEME_TOP_BAR_URL: 'theme_top_bar_url',
	THEME_TOP_BAR_COLOR: 'theme_top_bar_color',
	THEME_TOP_BAR_THEME: 'theme_top_bar_theme',

	// Name
	SPLASH_BACKGROUND: 'splash_background',
	SPLASH_BACKGROUND_VIDEO: 'splash_background_video',
	EMAIL_TLD: 'email_tld',
	COMPANY_NAME: 'company_name',
	LOGO_URL: 'logo_url',

	HM_EVENTS_ENABLED: 'hm_events_enabled',

	// Log-in
	LOG_IN_QR_CODE: 'log_in_qr_code',

	// Profile
	PROFILE_EDITING: 'profile_editing',
	PROFILE_ENABLE_PHOTO_EDITING: 'profile_enable_photo_editing',
	PROFILE_ENABLE_NAME_EDITING: 'profile_enable_name_editing',
	PROFILE_ENABLE_PHONENUMBER_EDITING: 'profile_enable_phonenumber_editing',
	PROFILE_ENABLE_LANDLINE_PHONENUMBER_EDITING: 'profile_enable_landline_phonenumber_editing',
	PROFILE_ENABLE_JOBTITLE_EDITING: 'profile_enable_jobtitle_editing',
	PROFILE_ENABLE_DEPARTMENT_EDITING: 'profile_enable_department_editing',
	PROFILE_ENABLE_TEAM_EDITING: 'profile_enable_team_editing',
	PROFILE_ENABLE_ERO_EDITING: 'profile_enable_ero_editing',
	PROFILE_ENABLE_ACCESS_CARD_ID_EDITING: 'profile_access_card_id_editing',

	// Workdays
	WORKDAY_EDITING: 'workday_editing',

	// Credits
	CREDITS_ENABLED: 'credits_enabled',

	// Privacy
	PRIVACY_EDITING: 'privacy_editing',
	PRIVACY_VISIBLE_FOR_EMPLOYEES_DEFAULT: 'privacy_visible_for_employees_default',
	PRIVACY_SHOW_PHONENUMBER: 'privacy_show_phonenumber',
	PRIVACY_SHOW_LANDLINE_PHONENUMBER: 'privacy_show_landline_phonenumber',
	PRIVACY_SHOW_CALENDAR: 'privacy_show_calendar',
	PRIVACY_SHOW_FAVOURITE: 'privacy_show_favourite',

	// ERO
	ERO_ENABLE: 'ero_enable',
	EMERGENCY_NUMBER: 'emergency_number',

	CONFIDANT_ENABLE: 'confidant_enable',
	
	COMMUTE_ENABLE: 'commute_enable',
	COMMUTE_FORCE_ENABLE: 'commute_force_enable',

	// Booking
	BOOKING_ENABLE_PARKING: 'booking_enable_parking',
	BOOKING_ENABLE_LUNCH: 'booking_enable_lunch',
	BOOKING_ENABLE_TRANSPORT_SELECT: 'transport_select_enabled',
	BOOKING_ENABLE_PARKING_LICENSE_PLATE: 'booking_enable_parking_license_plate',
	BOOKING_ENABLE_REASON: 'booking_enable_reason',

	// Coworker
	COWORKER_ENABLE_SCREEN: 'enable_coworkers_screen',
	COWORKER_SCREENS_SHOWS: 'coworker_screen_shows',
	COWORKER_ENABLE_SEARCH: 'coworker_enable_search',
	COWORKER_ENABLE_LINK_SHARE: 'enable_coworkers_link_share',
	COWORKER_ENABLE_DIRECT_SHARE: 'enable_coworkers_direct_share',

	COWORKER_CALENDER_ONLY_FROM_TEAM: 'coworker_calender_only_for_team',
	COWORKER_FAVOURITE_ONLY_FROM_TEAM: 'coworker_favourite_only_for_team',
	COWORKER_PHONENUMBER_ONLY_FROM_TEAM: 'coworker_phonenumber_only_for_team',

	COWORKER_SHOW_EMAILADDRESS: 'coworker_show_emailaddress',
	COWORKER_SHOW_PHONENUMBER: 'coworker_show_phonenumber',
	COWORKER_SHOW_LANDLINE_PHONENUMBER: 'coworker_show_landline_phonenumber',

	COWORKER_SEARCH_COMPANY: 'coworker_search_company',
	COWORKER_SEARCH_TEAM: 'coworker_search_team',
	COWORKER_SEARCH_DEPARTMENT: 'coworker_search_department',
	COWORKER_SEARCH_JOBTITLE: 'coworker_search_jobtitle',

	//
	SCAN_ENABLE_PRESENCE_METER: 'scan_enable_presence_meter',
	SCAN_ENABLE_TIME: 'scan_enable_time',
	SCAN_IN_ENABLED: 'scan_in_enabled',
	SCAN_IN_TYPE: 'scan_in_type',
	SCAN_OUT_ENABLED: 'scan_out_enabled',
	SCAN_OUT_TYPE: 'scan_out_type',
	ENABLE_TEAMS: 'enable_teams',
	AD_SYNC_ENABLED: 'ad_sync_enabled',
	CALENDAR_MIN_DATE: 'calendar_min_date',
	CALENDAR_MAX_DATE: 'calendar_max_date',
	MAINTENANCE: "maintenance",

	QR_CODE_INFORMATION_FILE: 'qr_code_information_file',

	NATIVE_APP_VERSION_REQUIREMENT: "native_app_version_requirement",
	OTA_APP_VERSION_REQUIREMENT: "ota_app_version_requirement"
};

export const settingsDefaultValues = {
	// Theme
	[ settingsConstants.THEME_TOP_BAR_URL ]: null,
	[ settingsConstants.THEME_TOP_BAR_COLOR ]: null,
	[ settingsConstants.THEME_TOP_BAR_THEME ]: null,

	// Name
	[ settingsConstants.SPLASH_BACKGROUND ]: null,
	[ settingsConstants.EMAIL_TLD ]: null,
	[ settingsConstants.COMPANY_NAME ]: null,
	[ settingsConstants.LOGO_URL ]: null,

	[ settingsConstants.HM_EVENTS_ENABLED ]: settingsOptions.NO,

	// Log-in
	[ settingsConstants.LOG_IN_QR_CODE ]: settingsOptions.YES,

	// Profile
	[ settingsConstants.PROFILE_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_PHOTO_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_NAME_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_PHONENUMBER_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_LANDLINE_PHONENUMBER_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_JOBTITLE_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_DEPARTMENT_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_TEAM_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_ERO_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PROFILE_ENABLE_ACCESS_CARD_ID_EDITING ]: settingsOptions.NO,

	// Workday
	[ settingsConstants.WORKDAY_EDITING ]: settingsOptions.YES,

	// Privacy
	[ settingsConstants.PRIVACY_EDITING ]: settingsOptions.YES,
	[ settingsConstants.PRIVACY_VISIBLE_FOR_EMPLOYEES_DEFAULT ]: settingsOptions.YES,
	[ settingsConstants.PRIVACY_SHOW_PHONENUMBER ]: privacyOptions.TEAM,
	[ settingsConstants.PRIVACY_SHOW_LANDLINE_PHONENUMBER ]: privacyOptions.TEAM,
	[ settingsConstants.PRIVACY_SHOW_CALENDAR ]: privacyOptions.TEAM,
	[ settingsConstants.PRIVACY_SHOW_FAVOURITE ]: privacyOptions.TEAM,

	// Other
	[ settingsConstants.ERO_ENABLE ]: settingsOptions.YES,
	[ settingsConstants.EMERGENCY_NUMBER ]: '112',

	[ settingsConstants.CONFIDANT_ENABLE ]: settingsOptions.YES,

	// Booking
	[ settingsConstants.BOOKING_ENABLE_PARKING ]: settingsOptions.YES,
	[ settingsConstants.BOOKING_ENABLE_LUNCH ]: settingsOptions.YES,
	[ settingsConstants.BOOKING_ENABLE_TRANSPORT_SELECT ]: settingsOptions.YES,
	[ settingsConstants.BOOKING_ENABLE_REASON ]: settingsOptions.NO,
	[ settingsConstants.BOOKING_ENABLE_PARKING_LICENSE_PLATE ]: settingsOptions.NO,

	// Coworker
	[ settingsConstants.COWORKER_ENABLE_SCREEN ]: settingsOptions.YES,
	[ settingsConstants.COWORKER_ENABLE_SEARCH ]: settingsOptions.YES,
	[ settingsConstants.COWORKER_ENABLE_LINK_SHARE ]: settingsOptions.NO,
	[ settingsConstants.COWORKER_ENABLE_DIRECT_SHARE ]: settingsOptions.NO,
	[ settingsConstants.COWORKER_SCREENS_SHOWS ] : 'teams',

	[ settingsConstants.COWORKER_CALENDER_ONLY_FROM_TEAM ] : settingsOptions.YES,
	[ settingsConstants.COWORKER_FAVOURITE_ONLY_FROM_TEAM ] : settingsOptions.YES,
	[ settingsConstants.COWORKER_PHONENUMBER_ONLY_FROM_TEAM ] : settingsOptions.YES,

	[ settingsConstants.COWORKER_SHOW_EMAILADDRESS ] : settingsOptions.NO,
	[ settingsConstants.COWORKER_SHOW_PHONENUMBER ] : settingsOptions.NO,
	[ settingsConstants.COWORKER_SHOW_LANDLINE_PHONENUMBER ] : settingsOptions.NO,

	[ settingsConstants.COWORKER_SEARCH_COMPANY ]: settingsOptions.YES,
	[ settingsConstants.COWORKER_SEARCH_TEAM ]: settingsOptions.YES,
	[ settingsConstants.COWORKER_SEARCH_DEPARTMENT ]: settingsOptions.YES,
	[ settingsConstants.COWORKER_SEARCH_JOBTITLE ]: settingsOptions.YES,

	[ settingsConstants.SCAN_IN_ENABLED ]: settingsOptions.YES,
	[ settingsConstants.SCAN_IN_TYPE ]: scanThroughConstants.QRCODE,
	[ settingsConstants.SCAN_OUT_ENABLED ]: settingsOptions.YES,
	[ settingsConstants.SCAN_OUT_TYPE ]: scanThroughConstants.QRCODE,
	[ settingsConstants.SCAN_ENABLE_PRESENCE_METER ]: settingsOptions.YES,
	[ settingsConstants.SCAN_ENABLE_TIME ]: settingsOptions.YES,

	[ settingsConstants.AD_SYNC_ENABLED ]: settingsOptions.NO,
	[ settingsConstants.ENABLE_TEAMS ]: settingsOptions.YES,

	[ settingsConstants.CALENDAR_MIN_DATE ]: 'week:0',
	[ settingsConstants.CALENDAR_MAX_DATE ]: 'month:2',

	[ settingsConstants.MAINTENANCE ] : settingsOptions.NO,

	[ settingsConstants.EMERGENCY_NUMBER ] : '112',

	[ settingsConstants.NATIVE_APP_VERSION_REQUIREMENT ] : '1.0.0',
	[ settingsConstants.OTA_APP_VERSION_REQUIREMENT ] : '1.0.0',
}
